import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { base as viemBase } from 'viem/chains'

import type { AppChain } from './chain.types'

export const base = viemDefineChain({ ...viemBase, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Base Mainnet',
    shortName: 'Base',
    safeShortName: 'base',
    morphoChainSlug: 'base',
    defiLlamaSlug: 'base',
    isIconSquare: true,
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://basescan.org', name: 'BaseScan' },
    simplePermitTokens: [
      '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913', // USDC
      '0x59aaF835D34b1E3dF2170e4872B785f11E2a964b' // verUSDC
    ],
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x46415998764C29aB2a25CbeA6254146D50D22687',
          startBlock: 13977152n
        },
        MorphoBlue: {
          address: '0xBBBBBbbBBb9cC5e90e3b3Af64bdAF62C37EEFFCb',
          startBlock: 13977148n
        },
        MetaMorphoV10Factory: {
          address: '0xA9c3D3a366466Fa809d1Ae982Fb2c46E5fC41101',
          startBlock: 13978134n
        },
        MetaMorphoV11Factory: {
          address: '0xFf62A7c278C62eD665133147129245053Bbf5918',
          startBlock: 23928808n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x4501125508079A99ebBebCE205DeC9593C2b5857',
          startBlock: 35615206n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x133baC94306B99f6dAD85c381a5be851d8DD717c',
          startBlock: 35615206n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x9a1B378C43BA535cDB89934230F0D3890c51C0EB',
          startBlock: 39285528n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xF42D9c36b34c9c2CF3Bc30eD2a52a90eEB604642',
          startBlock: 35615206n
        },
        RegistryList: {
          address: '0x5C2531Cbd2cf112Cf687da3Cd536708aDd7DB10a',
          startBlock: 35615358n
        },
        BluePublicAllocator: {
          address: '0xAED282B8aD9257BB1272e93aE63A32A53621e412',
          startBlock: 50063965n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
